import { getOnStorage, removeFromStorage } from './storageFunctions';

const SESSION_EXPIRED_MESSAGE = 'Sessão expirada. Por favor, entre com sua conta novamente.';
let isLoggingOut = false;

export const clearSessionStorage = () => {
  removeFromStorage('login_date');
  removeFromStorage('token_magento');
  removeFromStorage('token_aws');
  removeFromStorage('temporary_token_aws');
  removeFromStorage('rca');
  removeFromStorage('selected_client');
  removeFromStorage('selected_rca');
  removeFromStorage('datasets');
  removeFromStorage('discounts');
  removeFromStorage('rca_usuario');
  removeFromStorage('cart_id');
  removeFromStorage('user_login_data');
  removeFromStorage('selected_brand');
  removeFromStorage('new_data_sets');
  localStorage.removeItem('@RCA_APP:selected_client');
  localStorage.removeItem('localTime');
  localStorage.removeItem('deviceTime');
  localStorage.removeItem('login_bootstrap');
};

export const getAxiosErrorStatus = (error: unknown): number | undefined => {
  const status = (error as any)?.response?.status ?? (error as any)?.status;
  return typeof status === 'number' ? status : undefined;
};

export const isUnauthorizedAxiosError = (error: unknown): boolean => {
  const status = getAxiosErrorStatus(error);
  if (status === 401 || status === 403) return true;

  const message = String((error as any)?.message || '').toLowerCase();
  const responseMessage = String((error as any)?.response?.data?.message || '').toLowerCase();
  const combined = `${message} ${responseMessage}`;

  return (
    combined.includes('unauthorized') ||
    combined.includes('acesso negado') ||
    combined.includes('access denied') ||
    combined.includes('expired')
  );
};

export const forceSessionExpiredLogout = async (message = SESSION_EXPIRED_MESSAGE) => {
  if (isLoggingOut) return;
  isLoggingOut = true;

  clearSessionStorage();

  try {
    const { deleteDB } = await import('@/talons/dbFunctions/useDBFunctions');
    deleteDB();
  } catch (error) {
    console.error('Falha ao limpar IndexedDB na expiração de sessão:', error);
  }

  window.alert(message);
  window.location.reload();
};

export const isUnauthorizedGraphQLError = (graphQLErrors: readonly any[] | undefined): boolean => {
  if (!graphQLErrors?.length) return false;

  return graphQLErrors.some((error) => {
    const category = String(error?.extensions?.category || '').toLowerCase();
    const message = String(error?.message || '').toLowerCase();
    return (
      category.includes('authorization') ||
      category.includes('graphql-authentication') ||
      message.includes('unauthorized') ||
      message.includes('acesso negado')
    );
  });
};

export const hasActiveSession = (): boolean => {
  return Boolean(getOnStorage('token_magento') && getOnStorage('rca_usuario'));
};
